// extracted by mini-css-extract-plugin
export var blue = "_3t-g";
export var brand = "_3t-c";
export var darkGrey = "_3t-f";
export var disabled = "_3t-6";
export var disabledSubtle = "_3t-7";
export var error = "_3t-8";
export var green = "_3t-h";
export var grey = "_3t-e";
export var icon = "_3t-0";
export var inherit = "_3t-b";
export var lightGrey = "_3t-d";
export var orange = "_3t-j";
export var pink = "_3t-l";
export var primary = "_3t-1";
export var purple = "_3t-m";
export var quaternary = "_3t-4";
export var quinary = "_3t-5";
export var red = "_3t-k";
export var secondary = "_3t-2";
export var success = "_3t-a";
export var tertiary = "_3t-3";
export var warning = "_3t-9";
export var white = "_3t-n";
export var yellow = "_3t-i";